import React, { useState } from 'react';
import { MealAddonsType } from 'utils/types';
import { ReactComponent as EditMealIcon } from 'assets/icons/edit-meal-icon.svg';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate-meal-icon.svg';
import { ReactComponent as ArchiveIcon } from 'assets/icons/archive-icon.svg';
import { Link } from 'react-router-dom';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import EditAddonModal from 'components/edit-addon-modal';

interface Props {
  item: MealAddonsType;
  dndActive: boolean;
  cardHovered: string | null;
  setCardHovered: (item: string | null) => void;
  activeAddonId: string;
  setActiveAddonId: (item: string) => void;
  duplicateUrl: string;
  setSelectAddonId: (item: string) => void;
  setShowDeleteAddonModal: (item: boolean) => void;
}

export default function Addon(props: Props) {
  const {
    item: addonItem,
    dndActive,
    cardHovered,
    duplicateUrl,
    setCardHovered,
    setActiveAddonId,
    setSelectAddonId,
    setShowDeleteAddonModal
  } = props;

  const [item, setItem] = useState<Record<string, any>>(addonItem ?? {});
  const [editModal, setEditModal] = useState(false);
  const { attributes, listeners, transform, transition, setNodeRef } = useSortable({
    id: item.id
  });

  const style = { transition, transform: CSS.Transform.toString(transform) };

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        className='addon-box h-[135px] px-5 w-full pt-4'
        onMouseEnter={() => setCardHovered(item.id)}
        onMouseLeave={() => setCardHovered(null)}>
        {cardHovered === item.id && !dndActive ? (
          <div className='w-full flex justify-end gap-2 text-white'>
            <div className='p-1 bg-[#BFBFBF] rounded-[5px] w-6 h-6 hover:bg-black bg-opacity-70 flex justify-center items-center cursor-pointer'>
              <EditMealIcon
                className='w-4 h-4'
                onClick={() => {
                  setActiveAddonId(item.id);
                  setEditModal(true);
                }}
              />
            </div>
            <Link
              to={`${duplicateUrl}/${item.meal_data?.name}`}
              className='p-1 bg-[#BFBFBF] rounded-[5px] w-6 h-6 hover:bg-black bg-opacity-70 flex justify-center items-center cursor-pointer'>
              <DuplicateIcon className='w-4 h-4' />
            </Link>
            <div
              onClick={() => {
                setSelectAddonId(item.id);
                setShowDeleteAddonModal(true);
              }}
              className='p-1 bg-[#BFBFBF] rounded-[5px] w-6 h-6 hover:bg-black bg-opacity-70 flex justify-center items-center cursor-pointer'>
              <ArchiveIcon className='w-4 h-4' />
            </div>
          </div>
        ) : (
          <div className='h-6' />
        )}
        <p className='text-sm font-medium text-center'>{item.name}</p>
        <p className='text-xs font-medium text-gray-5'>&#8358;{item.amount}</p>
      </div>
      {editModal ? (
        <EditAddonModal
          show={editModal}
          onClose={(data) => {
            if (data)
              setItem((i) => ({
                ...i,
                meal_data: {
                  ...i.meal_data,
                  name: data?.name,
                  amount: data.amount
                }
              }));
            setEditModal(false);
          }}
          data={{
            addon_ids: item.id,
            name: item?.name,
            amount: item.amount,
            addon_meal_id: item?.addon_meal_id
          }}
          multiple={false}
        />
      ) : null}
    </>
  );
}
